import { NavigateFunction } from 'react-router-dom';

export type ComboDetailNavigationState = {
    openComboId?: string;
};

export const COMBO_DETAIL_QUERY_PARAM = 'id_campanha';

export const navigateToComboDetail = (navigate: NavigateFunction, idCampanha: string) => {
    navigate('/combos', {
        state: { openComboId: idCampanha } satisfies ComboDetailNavigationState,
    });
};
